import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { RtUICoreA11yModule } from './a11y/a11y.module';
import { RtUICoreOverlayModule } from './overlay/overlay.module';
import { RtUICorePortalModule } from './portal/portal.module';
import { RtUICoreRtlModule } from './rtl/rtl.module';

const MODULES = [
  CommonModule,
  I18nModule,
  RtUICoreA11yModule,
  RtUICoreOverlayModule,
  RtUICorePortalModule,
  RtUICoreRtlModule,
];

@NgModule({
  imports: MODULES,
  exports: MODULES,
})
export class RtUICoreModule {
  public static forRoot(): ModuleWithProviders<RtUICoreModule> {
    return {
      ngModule: RtUICoreModule,
      providers: [
        ...(RtUICoreA11yModule.forRoot().providers || []),
        ...(RtUICoreOverlayModule.forRoot().providers || []),
        ...(RtUICorePortalModule.forRoot().providers || []),
      ],
    };
  }
}

export { KeyCode, ModifierKey } from './keycode';

export * from './a11y/a11y.module';
export * from './overlay/overlay.module';
export * from './portal/portal.module';
export * from './rtl/rtl.module';
